module.exports = __webpack_public_path__ + "img/champagne.d933c107.svg";